import styled, { css } from 'styled-components'
import ControlSize, { controlFontShadow, controlHeight } from '../../../types/control-size'
import Gradient, { gradientCss } from '../../../types/gradient'
import ButtonComponent from '../button'

export const Button = styled(ButtonComponent)<{ gradient?: Gradient; size: ControlSize }>`
    padding: 0;
    width: ${({ size }) => controlHeight(size)}px;

    > svg {
        display: block;
        margin: 0 auto;
    }

    ${({ gradient, size }) =>
        !!gradient &&
        css`
            > svg {
                filter: drop-shadow(${controlFontShadow(size)});
            }
        `}
`

export const Inverted = styled.span<{ color?: string; gradient?: Gradient; iconColor?: string }>`
    border-radius: inherit;
    height: 100%;
    display: block;
    width: 100%;

    ${({ color, gradient, iconColor }) => {
        const gradientColor = gradient ? gradientCss(gradient) : null
        const buttonColor = iconColor || color || '#fff'

        return css`
            background: ${gradientColor || buttonColor};
        `
    }}
`
